var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('SuccessfullySavedAlert'),_c('ModifySeriesName',{attrs:{"id":_vm.id,"name":_vm.name}}),_c('SoilType',{attrs:{"id":_vm.id,"name":_vm.name}}),_c('Classification',{attrs:{"id":_vm.id,"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }